import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/img/logo_icon.svg'
import _imports_1 from '@/img/close.svg'
import _imports_2 from '@/img/calendar_check.svg'


const _withScopeId = n => (_pushScopeId("data-v-0434a964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal p-3 text-center" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = { class: "right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "mapContainer recapMap mt-4"
}
const _hoisted_8 = { class: "recapPrenoBox mt-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "maxw-280 mx-auto mt-4" }
const _hoisted_17 = { class: "maxw-280 mx-auto" }
const _hoisted_18 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_component = _resolveComponent("map-component")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", null, [
      (!_ctx.prenotazioneData.isVideoCall)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_map_component, {
              pins: _ctx.pins,
              center: _ctx.prenotazioneData.centro.contactData.shippingAddress.latLong,
              zoom: 13
            }, null, 8, ["pins", "center"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", null, [
          (!_ctx.prevPrenotazione)
            ? (_openBlock(), _createElementBlock("b", _hoisted_10, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Il mio appuntamento",
                  text: "Il mio appuntamento"
                })
              ]))
            : (_openBlock(), _createElementBlock("b", _hoisted_11, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Stai spostando la tua prenotazione in questa data",
                  text: "Stai spostando la tua prenotazione in questa data"
                })
              ]))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$filters.date(_ctx.prenotazioneData.data, 'dddd DD MMMM YYYY')), 1),
          _hoisted_13,
          _createElementVNode("b", null, _toDisplayString(_ctx.$filters.timespan(_ctx.prenotazioneData.fascia.from)) + " - " + _toDisplayString(_ctx.$filters.timespan(_ctx.prenotazioneData.fascia.to)), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.prenotazioneData.centro.personalData.completeName), 1)
        ]),
        (_ctx.prenotazioneData.isVideoCall)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_localized_text, {
                localizedKey: "L'appuntamento si svolgerà tramite videochiamata",
                text: "L'appuntamento si svolgerà tramite videochiamata"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.prenotazioneData.centro.contactData.shippingAddress.typedAddress), 1))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_localized_text, {
          localizedKey: "Il trattamento avrà una durata indicativa di 60 minuti",
          text: "Il trattamento avrà una durata indicativa di 60 minuti"
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_localized_text, {
          localizedKey: "Potrai modificare la data e l’orario del tuo appuntamento fino a 72 ore prima",
          text: "Potrai modificare la data e l’orario del tuo appuntamento fino a 72 ore prima"
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
        }, [
          (!_ctx.prevPrenotazione)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 0,
                localizedKey: "Prenota",
                text: "Prenota"
              }))
            : (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                localizedKey: "Conferma modifica",
                text: "Conferma modifica"
              }))
        ])
      ])
    ])
  ]))
}